const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const sortBy = payload?.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
  //     const params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       sortBy
  //     };

  //     let url = `/api/school`;
  //     if (payload?.city) url = url.concat(`/city/${payload.city}`);

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });
  //     const { content, totalPages, totalElements } = data;

  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });

  //     return Promise.resolve(data);
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/school?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getCity({ commit }, { cityId, search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/school/city/${cityId}?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getSchool({ commit }, payload) {
    try {
      let schoolId;
      if (payload.schoolId) {
        schoolId = `&schoolId=${payload.schoolId}`;
      } else {
        schoolId = '';
      }
      const {
        data: { data }
      } = await window.axios.get(`/api/master-school/list?cityId=${payload.cityId}&educationalLevel=${payload.educationalLevel}${schoolId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getSchoolList({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/master-school/list-school`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getEducation({ commit }, cityId) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/master-school/educational-level?cityId=${cityId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getEducationList({ commit }, cityId) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/bank-soal/educational-level`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/school/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetailChart({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/school/${id}/report`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  save({ commit }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    if (payload.webUrl === null) {
      payload.webUrl = '';
    }
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    formData.append('roleId', 2);
    if (!payload.logo) formData.delete('logo');
    return window.axios.post('/api/school', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    if (payload.webUrl === null) {
      payload.webUrl = '';
    }
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    formData.append('roleId', 2);
    if (!payload.logo) formData.delete('logo');
    return window.axios.put(`/api/school/${payload.id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/school/${payload.schoolId}`);
  },

  // eslint-disable-next-line no-unused-vars
  downloadTemplate({ commit }) {
    return window.axios.get(`/api/school/template`, { responseType: 'arraybuffer' });
  },
  // eslint-disable-next-line no-unused-vars
  importData({ commit }, payload) {
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    return window.axios.post(`/api/school/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export default { namespaced, state, getters, mutations, actions };
